// import { navigate } from "gatsby";
import { navigate } from "gatsby-link";
import store from "../../../../store/store";
var CustomAlertClick = { "UI-MINIS3": function UIMINIS3() { navigate("/qnb/products/BBUSTS20M?discountCode=WSS3MINI"); store.dispatch({ type: "ui/setDialogOpen", payload: { status: false } }); } };
export default CustomAlertClick;
